import { useMutation } from "@tanstack/react-query";
import { getCMAApiClient } from "../../apis/comps/cma/api-factories";
import type { ReorderComparablePropertiesItem } from "../../apis/comps/cma/generated/models";
import { CMA_SCOPE_KEY } from "./cma.key";

type Props = {
  onSuccess?: () => void;
  onSettled?: () => void;
};

export type Params = {
  cmaId: string;
  order: ReorderComparablePropertiesItem[];
};

export const CMA_REORDER_COMPARABLE_PROPERTIES_MUTATION_KEY =
  "cma-reorder-comparable-properties";

export const useReorderComparableProperties = (props?: Props) => {
  const { onSuccess, onSettled } = props || {};
  const api = getCMAApiClient();
  const mutation = useMutation({
    mutationFn: async (params: Params) => {
      const { cmaId, order } = params;
      return await api.cMAControllerReorderComparableProperties({
        id: cmaId,
        reorderComparablePropertiesRequest: { order },
      });
    },
    onError: async (error) => {
      console.error(`Failed to reorder comparable properties`, error);
    },
    onSettled: () => {
      onSettled?.();
    },
    onSuccess: () => {
      onSuccess?.();
    },
    mutationKey: [
      CMA_SCOPE_KEY,
      CMA_REORDER_COMPARABLE_PROPERTIES_MUTATION_KEY,
    ],
  });

  return mutation;
};
